import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Header = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 2fr 1.5fr 1fr 1fr 1fr;
    gap: 24px;
    margin-top: 24px;
    padding: 0 24px;
    
    @media (max-width: ${theme.v3.breakpoints.md}) {      
      display: none;
    }
  `}
`;

export const HeaderCell = styled.div`
  ${({ theme }) => css`
    font-size: 14px;
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[40]};
    user-select: none;
    
    &:hover {
      color: ${theme.v3.colors.neutral[40]};
    }
  `}
`;

export const HeaderCellContent = styled.div`
  ${({ $clickable }) => css`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    cursor: ${$clickable ? 'pointer' : 'default'};

    svg {
      flex: 0 0 12px;
      width: 12px;
    }
  `}
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ListItem = styled.div`
  ${({ theme }) => css`
    display: grid;
    align-items: center;
    grid-template-columns: 2fr 1.5fr 1fr 1fr 1fr;
    gap: 24px;
    padding: 24px;
    border-radius: 16px;
    background-color: ${theme.v3.colors.neutral[100]};
    box-shadow: 0 2px 4px 0 ${theme.v3.colors.neutral[90]}24, 0 2px 4px 0 ${theme.v3.colors.neutral[90]}33;
    transition: all 0.2s ease;
    
    &:hover {
      box-shadow: 0 4px 8px 0 ${theme.v3.colors.neutral[90]}33, 0 2px 4px 0 ${theme.v3.colors.neutral[90]}40;
    }
    
    @media (max-width: ${theme.v3.breakpoints.md}) {
      grid-template-columns: 1fr;
    }
  `}
`;

export const Cell = styled.div`
  ${({ theme, align }) => css`
    display: flex;
    align-items: center;
    justify-content: ${align === 'right' ? 'flex-end' : 'flex-start'};
    gap: 8px;
    
    @media (max-width: ${theme.v3.breakpoints.md}) {
      align-items: flex-start;
      justify-content: space-between;
      gap: 4px;
    }
  `}
`;

export const CellLabel = styled.p`
  ${({ theme }) => css`
    font-weight: ${theme.v3.font.weights.regular};
    font-size: 14px;
    line-height: 1.5;
    color: ${theme.v3.colors.neutral[60]};
    margin: 0 0 2px 0;
  `}
`;

export const CellContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const ServerName = styled.p`
  ${({ theme }) => css`
    line-height: 1.5;
    font-size: 16px;
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;
  `}
`;

export const ServerDomain = styled.p`
  ${({ theme }) => css`
    font-size: 14px;
    line-height: 1.5;
    font-weight: ${theme.v3.font.weights.regular};
    color: ${theme.v3.colors.neutral[60]};
    margin: 0;
  `}
`;

export const ServerIp = styled.p`
  ${({ theme }) => css`
    font-size: 16px;
    line-height: 1.5;
    font-weight: ${theme.v3.font.weights.regular};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;
  `}
`;

export const Actions = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 32px;
    justify-content: flex-end;
    
    @media (max-width: ${theme.v3.breakpoints.md}) {
      justify-content: flex-start;
    }
  `}
`;

export const IconButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 8px;
    background-color: transparent;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
      background-color: ${theme.v3.colors.neutral[95]};
    }
  `}
`;

export const Favorite = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  cursor: pointer;
`;
